@if (theme; as t) {
  <button
    type="button"
    class="tts-chip"
    [style.background]="t.bg"
    [style.borderColor]="t.border"
    [style.color]="t.text"
    [title]="tooltip"
    (click)="onClick()"
  >
    <svg class="tts-chip-icon" viewBox="0 0 24 24" [attr.fill]="t.text" aria-hidden="true">
      <path d="M5 9v6h4l5 5V4l-5 5H5z" />
      <path d="M16.5 8.5a5 5 0 010 7" [attr.stroke]="t.text" stroke-width="1.8" fill="none" stroke-linecap="round" />
    </svg>
    <span class="tts-chip-dot" [style.background]="t.dot"></span>
    {{ t.label }}
  </button>
}
